export default "__VITE_ASSET__acd987ce__"